module.exports = __webpack_public_path__ + "img/bitmart-mobile.15516004.png";